import React from 'react';
import { Router } from './src';

export default function App() {
  return <Router />;
}
